import gql from 'graphql-tag';
import { ApolloError } from 'apollo-client';

export const ADDRESS_ATTRIBUTES_FRAGMENT = gql`
  fragment AddressAttributesFragment on RestAddressAttributesData {
    source
    firstName: first_name
    lastName: last_name
    addressLine1: address_line1
    addressLine2: address_line2
    countryCode: country_code
    postalCode: postal_code
    city
    state
    phone
  }
`;

export const ADDRESS_FRAGMENT = gql`
  fragment AddressFragment on RestAddressData {
    id
    type
    attributes @type(name: "RestAddressAttributesData") {
      ...AddressAttributesFragment
    }
  }
  ${ADDRESS_ATTRIBUTES_FRAGMENT}
`;

export type RestAddressAttributesData = {
  __typename: 'RestAddressAttributesData';
  source: string;
  firstName: string;
  lastName: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  postalCode: string;
  phone: string;
  countryCode: string;
};

export type RestAddressData = {
  __typename: 'RestAddressData';
  id: string;
  type: 'address' | 'addresses';
  attributes: RestAddressAttributesData;
};

export type AddressQueryVariables = {
  input: {
    data: {
      type: 'address';
      attributes: {
        first_name: string;
        last_name: string;
        address_line1: string;
        address_line2: string;
        city: string;
        state: string;
        postal_code: string;
        phone: string;
        country_code: string;
      };
    };
  };
};

export type DeleteAddressMutationVariables = {
  id: string;
};

type AddressApolloError =
  | (ApolloError & {
      networkError: Error & {
        result?: {
          errors: {
            code: string;
            detail: string[] | string;
            field?: string | null;
          }[];
        };
      };
    })
  | null;

export type ShippingAddressMutationError = Record<'network' | string, string>;

export const createShippingAddressError = (
  error: ApolloError | undefined
): ShippingAddressMutationError => {
  const mutationError: ShippingAddressMutationError = {};
  if (error) {
    const errorResults = (error as AddressApolloError)?.networkError?.result?.errors;

    if (errorResults) {
      errorResults.forEach(error => {
        mutationError[error.field ? error.field : 'network'] = Array.isArray(error.detail)
          ? error.detail[0]
          : error.detail;
      });
    }
  }
  return mutationError;
};
